import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const navSourceSelection = {
    name: "NAV Source Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose NAV Source",
    defaultConfig: {
        defaultValue: null,
        key: "NAV Source",
    },
    type: "input",
    category: "dashboard",
};
